export default {"src":"/_next/static/media/data-insights.218ead58.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};